<form #f="ngForm">

	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.FROMRECEIVEMOBILEWAREHOUSE.FROMRECEIVEMOBILEWAREHOSE' | localize }}<i class="text-danger">*</i></label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
				<mat-select class="form-control"
							placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.FROMRECEIVEMOBILEWAREHOUSE.FROMRECEIVEMOBILEWAREHOSE' | localize }}"
							[(ngModel)]="selectedMobilWarehouse"
							name="mobilWarehouseToBeDelivered"
							#mobilWarehouseToBeDelivered ="ngModel"
							(selectionChange)="onChangeMobilWareHouse()"
							required>
					<!--<mat-option>Lütfen Mobil Hedef Depo Seçiniz</mat-option>-->
					<mat-option *ngFor="let mobilWareHouse of (mobilWarehouses | async)" [value]="mobilWareHouse">{{mobilWareHouse.name}}</mat-option>

				</mat-select>
				<mat-error *ngIf="mobilWarehouseToBeDelivered.hasError('required')">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</mat-error>

				<!--<span *ngIf="showIsRequiredMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span>-->
		</div>
	</div>
</form>
